/** Route-level chunks: each bare `import()` becomes a separate Rolldown/Webpack chunk. */
import { lazy } from "react";
export const SiteVariableLogPage = lazy(() => import("../siteVariableLog").then((m) => ({ default: m.SiteVariableLogPage })));
export const DownloadTasksPage = lazy(() => import("../downloadTasks").then((m) => ({ default: m.DownloadTasksPage })));
export const CustomizedReportPage = lazy(() =>
  import("../pages/customizedReport").then((m) => ({ default: m.CustomizedReportPage }))
);
export const FlowChatPage = lazy(() =>
  import("../pages/flowChat/FlowChatPage").then((m) => ({ default: m.FlowChatPage }))
);
export const SmtpSettingsPage = lazy(() =>
  import("../pages/smtpSettings").then((m) => ({ default: m.SmtpSettingsPage }))
);
export const ReportTaskLogPage = lazy(() =>
  import("../pages/reportTaskLog").then((m) => ({ default: m.ReportTaskLogPage }))
);
export const SiteLogStatusPage = lazy(() => import("../siteLogStatus").then((m) => ({ default: m.SiteLogStatusPage })));
export const SnmpStatusPage = lazy(() => import("../snmpStatus").then((m) => ({ default: m.SnmpStatusPage })));
export const ModbusStatusPage = lazy(() => import("../modbusStatus").then((m) => ({ default: m.ModbusStatusPage })));
export const AlarmHistoryPage = lazy(() => import("../alarmHistory").then((m) => ({ default: m.AlarmHistoryPage })));
export const ControlActionLogPage = lazy(() => import("../controlActionLog").then((m) => ({ default: m.ControlActionLogPage })));
export const SiteOfflineHistoryPage = lazy(() => import("../siteOfflineHistory").then((m) => ({ default: m.SiteOfflineHistoryPage })));
export const AlarmRulesPage = lazy(() => import("../alarmRules").then((m) => ({ default: m.AlarmRulesPage })));
export const ActiveAlarmsPage = lazy(() => import("../activeAlarms").then((m) => ({ default: m.ActiveAlarmsPage })));
export const DatabaseSetupPage = lazy(() => import("../databaseSetup").then((m) => ({ default: m.DatabaseSetupPage })));
export const DatabaseStructurePage = lazy(() => import("../databaseStructure").then((m) => ({ default: m.DatabaseStructurePage })));
export const DatabaseStatusPage = lazy(() => import("../databaseStatus").then((m) => ({ default: m.DatabaseStatusPage })));
export const DatabaseStatusDbPage = lazy(() => import("../databaseStatus").then((m) => ({ default: m.DatabaseStatusDbPage })));
export const AlarmMappingPage = lazy(() => import("../alarmMapping").then((m) => ({ default: m.AlarmMappingPage })));
export const AlarmTypeMappingPage = lazy(() =>
  import("../alarmTypeMapping").then((m) => ({ default: m.AlarmTypeMappingPage }))
);
export const AlarmContactPage = lazy(() =>
  import("../pages/alarmContact").then((m) => ({ default: m.AlarmContactPage }))
);
export const OfflineAlarmRulesPage = lazy(() => import("../offlineAlarmRules").then((m) => ({ default: m.OfflineAlarmRulesPage })));
export const ModbusDevicesEditor = lazy(() => import("../modbusDevices").then((m) => ({ default: m.ModbusDevicesEditor })));
export const ModbusGatewaysEditor = lazy(() =>
  import("../features/modbus/ModbusGatewaysEditor").then((m) => ({ default: m.ModbusGatewaysEditor }))
);
export const AtCommandPage = lazy(() =>
  import("../features/modbus/AtCommandPage").then((m) => ({ default: m.AtCommandPage }))
);
export const UartSettingPage = lazy(() =>
  import("../features/modbus/UartSettingPage").then((m) => ({ default: m.UartSettingPage }))
);
export const ModbusTemplatesEditor = lazy(() => import("../modbusTemplates").then((m) => ({ default: m.ModbusTemplatesEditor })));
export const ModbusTemplateDetailEditor = lazy(() =>
  import("../features/modbus/ModbusTemplateDetailEditor").then((m) => ({ default: m.ModbusTemplateDetailEditor }))
);
export const CsuTemplatesEditor = lazy(() => import("../csuTemplates").then((m) => ({ default: m.CsuTemplatesEditor })));
export const ModbusPollDebugPage = lazy(() => import("../modbusPollDebug").then((m) => ({ default: m.ModbusPollDebugPage })));
export const WebhookLogPage = lazy(() => import("../webhookLog").then((m) => ({ default: m.WebhookLogPage })));
export const AccountActivityPage = lazy(() =>
  import("../features/users/AccountActivity").then((m) => ({ default: m.AccountActivityPage }))
);
export const WebhookSenderPage = lazy(() => import("../webhookSender").then((m) => ({ default: m.WebhookSenderPage })));
export const AlarmWebhookPage = lazy(() => import("../alarmWebhook").then((m) => ({ default: m.AlarmWebhookPage })));
export const ProjectManagementPage = lazy(() =>
  import("../projectManagement").then((m) => ({ default: m.ProjectManagementPage }))
);
export const PingTestPage = lazy(() => import("../pingTest").then((m) => ({ default: m.PingTestPage })));
export const SnmpTesterPage = lazy(() => import("../snmpTesterPage").then((m) => ({ default: m.SnmpTesterPage })));
export const RedisStatusPage = lazy(() => import("../redisStatus").then((m) => ({ default: m.RedisStatusPage })));
export const SystemSettingsPage = lazy(() => import("../systemSettings").then((m) => ({ default: m.SystemSettingsPage })));
export const ApiMonitorPage = lazy(() => import("../apiMonitor").then((m) => ({ default: m.ApiMonitorPage })));
export const UsersListPage = lazy(() => import("../userManagement").then((m) => ({ default: m.UsersListPage })));
export const UsersCreatePage = lazy(() => import("../userManagement").then((m) => ({ default: m.UsersCreatePage })));
export const UsersEditPage = lazy(() => import("../userManagement").then((m) => ({ default: m.UsersEditPage })));
export const ModbusDeviceViewPage = lazy(() => import("../modbusDeviceView").then((m) => ({ default: m.ModbusDeviceViewPage })));
export const ModbusDeviceOpenPage = lazy(() =>
  import("../features/modbus/ModbusDeviceOpenPage").then((m) => ({ default: m.ModbusDeviceOpenPage }))
);
export const DeviceUiConfigEditor = lazy(() =>
  import("../features/device-ui/DeviceUiConfigEditor").then((m) => ({ default: m.DeviceUiConfigEditor }))
);
export const SnmpConfigPage = lazy(() => import("../snmpConfig").then((m) => ({ default: m.SnmpConfigPage })));
export const MqttConfigPage = lazy(() => import("../mqttConfig").then((m) => ({ default: m.MqttConfigPage })));
export const DashboardDesign = lazy(() =>
  import("../features/dashboard/DashboardDesign").then((m) => ({ default: m.DashboardDesign }))
);
export const CsuDataPage = lazy(() =>
  import("../features/csu/CsuDataPage").then((m) => ({ default: m.CsuDataPage }))
);
export const CsuMappingPage = lazy(() =>
  import("../features/csu/CsuMappingPage").then((m) => ({ default: m.CsuMappingPage }))
);
export const DashboardMappingEditor = lazy(() =>
  import("../features/dashboard/DashboardMappingEditor").then((m) => ({ default: m.DashboardMappingEditor }))
);
export const SitesEditor = lazy(() =>
  import("../features/sites/SitesEditor").then((m) => ({ default: m.SitesEditor }))
);
export const InventorySitePage = lazy(() =>
  import("../pages/inventory/InventorySitePage").then((m) => ({ default: m.InventorySitePage }))
);
export const InventoryConfigPage = lazy(() =>
  import("../pages/inventory/InventoryConfigPage").then((m) => ({ default: m.InventoryConfigPage }))
);
export const MapViewPage = lazy(() => import("../pages/inventory/MapViewPage").then((m) => ({ default: m.MapViewPage })));
export const MapConfigPage = lazy(() =>
  import("../pages/inventory/MapConfigPage").then((m) => ({ default: m.MapConfigPage }))
);
export const AnalyticsPage = lazy(() =>
  import("../pages/analytics").then((m) => ({ default: m.AnalyticsPage }))
);
export const AnalyticsConfigPage = lazy(() =>
  import("../pages/analyticsConfig").then((m) => ({ default: m.AnalyticsConfigPage }))
);
export const ConnectorPage = lazy(() =>
  import("../pages/connector").then((m) => ({ default: m.ConnectorPage }))
);
export const TaskStatusPage = lazy(() =>
  import("../pages/inventory/TaskStatusPage").then((m) => ({ default: m.TaskStatusPage }))
);
